// import { People } from '@mui/icons-material';
import { Button, Popover } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Participant } from 'src/services/api/response/participant';
import { Colors } from 'src/shared/components/styles/colors';
import ParticipantsModal from './participantsModal';

type ParticipantsButtonProps = {
  items: Participant[];
};

const ParticipantsButton = (props: ParticipantsButtonProps) => {
  const { items } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { t } = useTranslation(['news']);

  const handleParticipantClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const openParticipants = Boolean(anchorEl);
  const id = openParticipants ? 'simple-popover' : undefined;

  // Räkna ut totalt antal plus 1-deltagare
  let total = 0;
  items?.forEach((element) => {
    total += Number(element.NumberOfInvitedPeople);
  });

  return (
    <>
      <Button
        aria-describedby={id}
        sx={{ color: Colors.ACCENT_DARK }}
        // endIcon={<People />}
        onClick={handleParticipantClick}
      >
        {t('show')} {items?.length + total} {t('participants')}
      </Button>
      <Popover
        id={id}
        open={openParticipants}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <ParticipantsModal participants={items} />
      </Popover>
    </>
  );
};

export default ParticipantsButton;
